import React, { Component, Fragment } from 'react';

const CalculatorContext = React.createContext();

export const CalculatorConsumer = CalculatorContext.Consumer;

export class CalculatorProvider extends Component {
  state = {
      lifestage: '',
      investment: 0,
      investmentTime: '30',
      startInvestment: 0,
      minInvestment: 0,
      maxInvestment: 0,
      increment: 0,
      investmentInput: false,
      amountErrorMsg: '',
  };

  displayInvestmentInput = () => {
    this.setState({
        investmentInput: !this.state.investmentInput,
    });
  };

  render() {

    return (
          <CalculatorContext.Provider value={{
            state: this.state,
            handleInvestmentField: name => (e) => {
              this.setState({
                [name]: e.target.value,
              })
            },
            handleChange: name => event => {
              let initStartInvestment, initMinInvestment, initMaxInvestment, initIncrement, initTenor;
                if (event.target.value === 'Empty Nester' || event.target.value === 'Retiree'){
                  initMinInvestment = 500000;
                  initMaxInvestment = 5000000;
                  initIncrement = 100000;
                  initStartInvestment = 500000;
                  initTenor = 30;
                }
                else {
                  initMinInvestment = 10000;
                  initMaxInvestment = 490000;
                  initIncrement = 10000;
                  initStartInvestment = 10000;
                  initTenor = 30;
                }
                this.setState({
                  [name]: event.target.value,
                  startInvestment: initStartInvestment,
                  investment: initStartInvestment,
                  minInvestment: initMinInvestment,
                  maxInvestment: initMaxInvestment,
                  increment: initIncrement,
                  investmentTime: initTenor,
                  investmentInput: false,
                });
              },

            handleExtendedInvestment: name => event => {
              if (event.target.value < 10000){
                this.setState({
                  amountErrorMsg: "Amount should not be less than P10,000."
                });
              }
              else if (event.target.value > 5000000 ){
                this.setState({
                  amountErrorMsg: "Amount should not be more than P5,000,000."
                });
              }
              else{
                this.setState({
                  amountErrorMsg: ''
                });
              }

              this.setState({
                [name]: event.target.value,
              });
            },

            handleInvestment: (investment) => {
              this.setState({
                investment: investment,
              });
            },

            handleTenor: (investmentTime) => {
              this.setState({
                investmentTime,
              });
            },

            onSubmit: (e) => {
              e.preventDefault();
              this.displayInvestmentInput();
            },
          }}>

          <Fragment>
              {this.props.children}
          </Fragment>

        </CalculatorContext.Provider>
    )
  }
  ;
}

